import { createReducer, on, createFeature, provideState } from '@ngrx/store';
import { OverlayActions } from './overlay.actions';
import { EmailTranscriptActions } from '../email-transcript/email-transcript.actions';
import { VaSessionActions } from '../va-session/va-session.actions';
import { OverlayEffects } from './overlay.effects';
import { makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { PostEscalationCurationActions } from '../post-escalation-curation/post-escalation-curation.actions';
import { OverlayType } from '../../types/enum';

export const initialState: Readonly<OverlayState> = {
  isVisible: false,
  type: OverlayType.Empty,
};

export const overlayFeature = createFeature({
  name: 'overlay',
  reducer: createReducer(
    initialState,
    on(OverlayActions.showOverlay, (state, { value }) => {
      return { ...state, isVisible: true, type: value };
    }),
    on(
      OverlayActions.closeOverlay,
      OverlayActions.closeApplication,
      EmailTranscriptActions.setSubmitted,
      EmailTranscriptActions.setFailed,
      VaSessionActions.expireSession,
      PostEscalationCurationActions.updateSelectedItems,
      (state) => {
        return { ...state, isVisible: false, type: OverlayType.Empty };
      }
    )
  ),
});

export const { selectIsVisible, selectType, selectOverlayState } =
  overlayFeature;

export function provideOverlayFeature() {
  return makeEnvironmentProviders([
    provideState(overlayFeature),
    provideEffects(OverlayEffects),
  ]);
}
